import {QueryValue} from '.';

export type filterType = {value: boolean};

//Fromval could be "Y" for true or undefined for false;
//Undefined operator means "="
export function serialize(queryValue: QueryValue): filterType {
    const {fromval, op} = queryValue;
    return {
        value: !op || op === '=' ? !!fromval : !fromval
    };
}

export function deserialize({value}: filterType): Partial<QueryValue> {
    return {
        fromval: 'Y',
        op: value ? '=' : '<>'
    };
}
